// extracted by mini-css-extract-plugin
export var section = "_2l-1";
export var topNav = "_2l-0";